import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Page } from '@style/Shared';
import { AzureAuthHelper } from '@client/core/auth/azure/AzureAuthHelper';
import { context } from '@client/context';
import { LoginLogoutButton } from '@client/modules/Auth/LoginLogoutButton';
import { Colors } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import ContentPageStore, { IContentPageState } from '@client/store/ContentPageStore';
import Menu from '@client/modules/Menu/Menu';
import BackgroundHazeSvg from '@client/assets/svgs/background-haze.svg';

const StyledPage = styled(Page)`
	min-height: 100vh;
	${TextStyle.family('title')}
	background-color: ${Colors.newsBackground};
`;

const Center = styled(Page)`
	width: 50%;
	height: 100%;
	display: flex;
	justify-content: center;

	h1 {
		text-align: center;
	}
`;

const BackgroundHaze = styled.div<{ $color?: string }>`
	position: fixed;
	top: 0px;
	left: -80vw;
	width: 250vw;
	height: 250vh;
	z-index: 0;
	pointer-events: none;
	color: ${props => props.$color};
`;

export default function AuthPage(_: { content?: any }) {
	const [message, setMessage] = useState<string>('');
	const [showLogin, setShowLogin] = useState<boolean>(false);

	let timeout: number | undefined;

	const themeColors: IContentPageState = ContentPageStore.use(state => state);

	useEffect(() => {
		const code = AzureAuthHelper.extractCodeFromLocation();

		// logged in
		if (code) {
			setMessage('Smukt! Nu er du logget ind.<br />Find ”Mit Smuk” i menuen.');
			timeout = window.setTimeout(() => {
				context.auth.signInDone(code);
			}, 2000);
			return;
		}

		// user created
		const idToken = AzureAuthHelper.extractIdTokenFromLocation();
		if (idToken) {
			setMessage('Din bruger er oprettet, venligst login for at fortsætte.');
			setShowLogin(true);
			return;
		}

		setMessage('Noget gik galt<br />...vi sender dig tilbage der hvor du kom fra!');

		return () => {
			if (timeout) {
				clearTimeout(timeout);
				timeout = undefined;
			}
		};
	}, []);

	return (
		<StyledPage>
			<BackgroundHaze $color={themeColors.contrastColor}>
				<BackgroundHazeSvg />
			</BackgroundHaze>

			<Menu specificColor={Colors.footerDarkBackground} showLogin={false} />

			<Center>
				<h1 dangerouslySetInnerHTML={{ __html: message }}></h1>

				{showLogin && <LoginLogoutButton rememberPath={false} />}
			</Center>
		</StyledPage>
	);
}
